export default __webpack_public_path__ + "static/nathan-bitmoji-14ca5c7c98a6f4aff6e13483bd041ae5.png";